import { combineReducers } from "redux";
import portalReducer from "./portalReducer";

export default combineReducers({
    portalReducer,
});